import { Vector2 } from 'three';
import { logger } from '@/modules/common/logging/logger';
import { ConnectionDirections } from '@/modules/contextMenu/types';
import { IContextMenuService } from './IContextMenuService';

export class ContextMenuServiceExceptionDecorator implements IContextMenuService {
  private decoree: IContextMenuService;

  constructor(decoree: IContextMenuService) {
    this.decoree = decoree;
  }

  setPosition(position: Vector2 | null): void {
    try {
      this.decoree.setPosition(position);
    } catch (err) {
      this.logError('setPosition', err);
    }
  }

  setContext(context: 'AREA' | 'CONNECTION' | 'CONTROL_POINT' | null): void {
    try {
      this.decoree.setContext(context);
    } catch (err) {
      this.logError('setContext', err);
    }
  }

  setRelatedComponentId(id: string | undefined): void {
    try {
      this.decoree.setRelatedComponentId(id);
    } catch (err) {
      this.logError('setRelatedComponentId', err);
    }
  }

  setRelatedControlPoint(
    controlPoint: { elementId: string; pointIndex: number } | undefined,
  ): void {
    try {
      this.decoree.setRelatedControlPoint(controlPoint);
    } catch (err) {
      this.logError('setRelatedControlPoint', err);
    }
  }

  setRelatedAreaIds(ids: string[]): void {
    try {
      this.decoree.setRelatedAreaIds(ids);
    } catch (err) {
      this.logError('setRelatedAreaIds', err);
    }
  }

  setActiveConnectionTab(tab: ConnectionDirections | undefined): void {
    try {
      this.decoree.setActiveConnectionTab(tab);
    } catch (err) {
      this.logError('setActiveConnectionTab', err);
    }
  }

  reset(): void {
    try {
      this.decoree.reset();
    } catch (err) {
      this.logError('reset', err);
    }
  }

  private logError(methodName: string, err: unknown): void {
    logger.error(`ContextMenuService.${methodName} failed:`, err);
  }
}
